import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { useProject } from '../../../../context/ProjectContext';
import { changeLikedImagesTable } from '../../../../redux/id8/id8Reducer';
import SearchInput from '../../../../components/common-inputs/SearchInput';
import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { IMAGES_PAGE_SIZE_OPTIONS } from '../../frames/filters/FrameFilters';
import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';

import scss from './LikedFilters.module.scss';

function LikedFilters() {
  const dispatch = useDispatch();
  const { t } = useTranslation('id8');
  const { id } = useParams();

  const { actions } = useProject();

  const likedImagesTableSettings = useSelector((state) => state.id8.likedImagesTableSettings);

  const handleChangeSearch = (newSearch) => {
    dispatch(changeLikedImagesTable({ searchQuery: newSearch, page: 1 }));
  };

  const handleChangeSize = (newSize) => {
    dispatch(changeLikedImagesTable({ size: newSize }));
  };

  useEffect(() => {
    // actions('getLikedImages', id);
    console.log('getLikedImages');
  }, [
    actions,
    id,
    likedImagesTableSettings.searchQuery,
    likedImagesTableSettings.page,
    likedImagesTableSettings.sort,
    likedImagesTableSettings.size,
  ]);

  return (
    <div className={scss.wrapper}>
      <SearchInput
        value={likedImagesTableSettings.searchQuery}
        onChange={handleChangeSearch}
        size='sm'
        maxWidth={364}
      />

      <div className={scss.rightSection}>
        <WithLabel variant={LABEL_STYLES.ROW} label={t('show')} maxWidth={168}>
          <CommonDropdown
            value={likedImagesTableSettings.size}
            onSelect={handleChangeSize}
            options={IMAGES_PAGE_SIZE_OPTIONS}
          />
        </WithLabel>
      </div>
    </div>
  );
}

export default LikedFilters;
